import { Union } from 'ts-toolbelt';

import { SupplierContactDetailsQuery } from '@/generated/gql/graphql.ts';
import { ContactEditInput } from '~/common/types/ContactEditInput.ts';
import { SupplierContactData } from '~/routes/IntakeDetail/components/SupplierContactEditDialog/components/SupplierContactEditForm/SupplierContactEditForm.schema.ts';

type SupplierContactQueryData = SupplierContactDetailsQuery['cmdi']['contact'][number];

export const toSupplierContactFormData = (
  data: Union.Nullable<SupplierContactQueryData>,
): SupplierContactData | null => {
  return data
    ? {
        internalId: data.id,
        supplierId: data.supplierId,
        firstName: data.firstName,
        lastName: data.lastName,
        role: data.role,
        email: data.email,
        language: data.preferredLanguage,
      }
    : null;
};

export const fromSupplierContactFormData = (data: SupplierContactData): ContactEditInput => {
  return {
    id: data.internalId,
    title: null,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    role: data.role as any,
    preferredLanguage: data.language as any,
    supplierId: data.supplierId,
  };
};
